import script from "./CompanyHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyHandler.vue?vue&type=script&setup=true&lang=js"

import "./CompanyHandler.vue?vue&type=style&index=0&id=75cfdd74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75cfdd74"]])

export default __exports__